import { ReadingPageFooter } from './ReadingPageFooter'
import { withReadingPageFooter } from './withReadingPageFooter'

const ConnectedReadingPageFooter = withReadingPageFooter(ReadingPageFooter)

export { ConnectedReadingPageFooter as ReadingPageFooter }
